export type CommentsOrdering = "createdAt" | "-createdAt";

export const DEFAULT_COMMENTS_ORDER: CommentsOrdering = "createdAt";
